/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the EventBasicDto interface.
 */
export function instanceOfEventBasicDto(value) {
    if ((!('eventId' in value) && !('event_id' in value)) || (value['eventId'] === undefined && value['event_id'] === undefined))
        return false;
    if ((!('eventDate' in value) && !('event_date' in value)) || (value['eventDate'] === undefined && value['event_date'] === undefined))
        return false;
    if ((!('eventTitle' in value) && !('event_title' in value)) || (value['eventTitle'] === undefined && value['event_title'] === undefined))
        return false;
    if ((!('songCount' in value) && !('song_count' in value)) || (value['songCount'] === undefined && value['song_count'] === undefined))
        return false;
    if ((!('clientName' in value) && !('client_name' in value)) || (value['clientName'] === undefined && value['client_name'] === undefined))
        return false;
    if ((!('endpointUrl' in value) && !('endpoint_url' in value)) || (value['endpointUrl'] === undefined && value['endpoint_url'] === undefined))
        return false;
    return true;
}
export function EventBasicDtoFromJSON(json) {
    return EventBasicDtoFromJSONTyped(json, false);
}
export function EventBasicDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'eventId': json['event_id'],
        'eventDate': json['event_date'],
        'eventTitle': json['event_title'],
        'songCount': json['song_count'],
        'clientName': json['client_name'],
        'endpointUrl': json['endpoint_url'],
    };
}
export function EventBasicDtoToJSON(json) {
    return EventBasicDtoToJSONTyped(json, false);
}
export function EventBasicDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'event_id': value['eventId'],
        'event_date': value['eventDate'],
        'event_title': value['eventTitle'],
        'song_count': value['songCount'],
        'client_name': value['clientName'],
        'endpoint_url': value['endpointUrl'],
    };
}
